import { render, staticRenderFns } from "./TeamsHeader.vue?vue&type=template&id=3defbf99&"
import script from "./TeamsHeader.vue?vue&type=script&lang=js&"
export * from "./TeamsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports